// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__26Xce","bigColWidth":"Table_bigColWidth__1SsYV","biggerColWidth":"Table_biggerColWidth__1jY4w","row":"Table_row__2wE5E","col":"Table_col__3abZ8"};